import React, { useState } from 'react'
import TabButtonSection from '../TabButtonSection'
import CasinoTabCardsSection from '../CasinoTabCardsSection'
import MiniTabCardsSection from '../MiniTabCardsSection'
import SlotTabCardsSection from '../SlotTabCardsSection'

const TabSection = () => {
    const [activeTab, setActiveTab] = useState(1)
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex)
    }
    return (
        <>
            <section className="tab-section lg:px-[50px] lg:py-[30px]">
                <TabButtonSection activeTab={activeTab} handleTabClick={handleTabClick} />
                <div className="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2.5 lg:gap-[15px] xl:gap-[15px] py-2.5 px-2.5 lg:px-5 ">
                    {activeTab === 1 && <CasinoTabCardsSection />}
                    {activeTab === 2 && <SlotTabCardsSection />}
                    {activeTab === 3 && <MiniTabCardsSection />}
                </div>
            </section>
        </>
    )
}

export default TabSection